/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


$('#form-send-link').submit(function(event){
    event.preventDefault();
    let link = $(this).attr('action');
    let formData = new FormData(document.getElementById("form-send-link"));
    if($('#data-member').val().length == 9 || $('#data-member').val().length == 6){
        $.ajax({
            url: link,
            type: "POST",
            dataType: "json",
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            beforeSend: function(){
                $('#send-button').attr('disabled');
            },
            success: function(data){
                $('#recoverPassMessage').addClass('alert-success');
                $('#recoverPassMessage').html(data.messages);
                $('#recoverPassMessage').show();
                return false;
            },
            error: function(data){
                $('#recoverPassMessage').addClass('alert-danger');
                $('#recoverPassMessage').html(data.responseJSON.messages);
                $('#recoverPassMessage').show();
               return false;
            }
        });
    }else{
        alert('Debe escribir una membresia válida');
    }
});

$('#form-send-pass').submit(function(event){
    event.preventDefault();
    let link = $(this).attr('action');
    let formData = new FormData(document.getElementById("form-send-pass"));
    if($('#data-newp').val() === $('#data-newp2').val()){
        $.ajax({
            url: link,
            type: "POST",
            dataType: "json",
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            beforeSend: function(){
                $('#send-button').attr('disabled');
            },
            success: function(data){
                $('#message-alert-pass .modal-content').removeClass('modal-dialog-error');
                $('#messageAlertLabel').removeClass('messageAlertLabel-error');
                $('#message-alert-pass .modal-content').addClass('modal-dialog-success');
                $('#messageAlertLabel').addClass('messageAlertLabel-success');
                $('#messageAlertLabel').text('ÉXITO!');
                $('#messageAlert').html(data.messages);
                $('#message-alert-pass').modal('show');
                
            },
            error: function(data){
                $('#message-alert-pass .modal-content').removeClass('modal-dialog-success');
                $('#messageAlertLabel').removeClass('messageAlertLabel-success');
                $('#message-alert-pass .modal-content').addClass('modal-dialog-error');
                $('#messageAlertLabel').addClass('messageAlertLabel-error');
                $('#messageAlertLabel').text('ERROR!');
                $('#messageAlert').html(data.responseJSON.messages);
                $('#message-alert-pass').modal('show');
            }
        });
    }else{
        alert('Ambos campos deben coincidir');
    }
});

$('#message-alert-pass').on('hidden.bs.modal', function(e){
    $('#send-button').removeAttr('disabled');
});


$('#data-newp').keyup(function(){
    $('#strengthMessage').html(checkStrength($('#data-newp').val()));
});

$('#data-newp2').keyup(function(){
    let datanewp = $('#data-newp').val();
    let datanewp2 = $('#data-newp2').val();
    if( datanewp === datanewp2){
        $('#passConfirmMessage').removeClass();
        $('#passConfirmMessage').addClass('Strong');
        $('#passConfirmMessage').html('Coinciden');
    }else{
        $('#passConfirmMessage').removeClass();
        $('#passConfirmMessage').addClass('Insecure');
        $('#passConfirmMessage').html('No Coinciden');
    }
});

function checkStrength(password){
    
    let strength = 0;
    if (password.length < 6) {
        $('#strengthMessage').removeClass();
        $('#strengthMessage').addClass('Short');
        return 'Muy Corta';
    }
    if(verifyPass(password) == 'Insegura') return 'Insegura';
    if (password.length > 7) strength += 1
    // If password contains both lower and uppercase characters, increase strength value.
    if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) strength += 1;
    // If it has numbers and characters, increase strength value.
    if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)) strength += 1;
    // If it has one special character, increase strength value.
    if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) strength += 1
    // If it has two special characters, increase strength value.
    if (password.match(/(.*[!,%,&,@,#,$,^,*,?,_,~].*[!,%,&,@,#,$,^,*,?,_,~])/)) strength += 1;
    // Calculated strength value, we can return messages
    // If value is less than 2
    if (strength < 2) {
        $('#strengthMessage').removeClass()
        $('#strengthMessage').addClass('Weak');
        return 'Débil'
    } else if (strength == 2) {
        $('#strengthMessage').removeClass();
        $('#strengthMessage').addClass('Good');
        return 'Buena';
    } else {
        $('#strengthMessage').removeClass()
        $('#strengthMessage').addClass('Strong');
        return 'Segura';
    }
}

function verifyPass(password){
    $.ajax({
        url: '/checkpass',
        dataType: "json",
        data: {q: password},
        type: "POST",
        success: function (data) {
            if(data.messages == 'Insegura'){
                $('#strengthMessage').removeClass();
                $('#strengthMessage').addClass('Insecure');
                $('#strengthMessage').html(data.messages);
            }
            
        }
    });
    return $('#strengthMessage').text();
}